import { generateClient } from "aws-amplify/api";
const client = generateClient();
import { list_master_checklists } from '@/graphql/queries'

export default {
  data() {
    return {
      checklistsList: [],
    }
  },
  methods: {
    async fetchChecklists(input = {}) {
      try {
        const response = await client.graphql({
          query: list_master_checklists,
          variables: {
            input: input,
          },
        })

        let responseData = JSON.parse(response.data.list_master_checklists)
        // console.log(responseData)
        if (responseData.status == "SUCCESS") {
          this.checklistsList = (responseData.data || []).filter(
            (item) => item.checklist_status !== "DELETED"
          )
        } else {
          this.checklistsList = []
        }
        // console.log(this.checklistsList)

      } catch (error) {
        console.error("Error fetching checklists:", error);
        if (error == 'NoValidAuthTokens: No federated jwt') {
          this.$router.push("/login");
          this.$store.dispatch("logout");
          this.$store.dispatch("clearAuth");
          this.$store.dispatch("clearUser");
          this.$store.dispatch("clearToken");
          this.$store.dispatch("clearRefreshToken");
          this.$store.dispatch("clearExpiresAt");
          this.$store.dispatch("clearExpiresIn");
        }
        this.checklistsList = [];
        throw error;
      }
    },
  },
};

